import {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, User, ShieldCheck } from 'lucide-react';
import { useAuth } from '../../context/useAuth';
import { useReports } from '../../context/useReports'; // Import the custom hook to access ReportContext
// import api from '../../utils/api';


const Header = () => {
  const { user, logout } = useAuth();
 // const navigate = useNavigate();
  // const [error, setError] = useState(''); // Add this line
  const { lastUpdate } = useReports(); // Access lastUpdate from ReportContext

  return (
    <header className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-[100]">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* REDUCED: Changed py-4 to py-2 to shrink vertical height */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between py-2 gap-4">

          {/* LEFT SECTION */}
          <div className="flex items-center gap-3 group"> {/* REDUCED: gap-4 to gap-3 */}
            
            {/* Logo - REDUCED: Changed w-14/h-14 to w-10/h-10 */}
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
              <img
                src="/CountyLogo1.png"
                alt="County Government Official Logo"
                className="h-full object-contain"
              />
            </div>

            {/* Titles */}
            <div>
              {/* REDUCED: Smaller font sizes (text-sm/text-base) and tighter leading */}
              <h1 className="text-sm sm:text-base md:text-lg font-bold text-gray-900 leading-tight">
                 Embu County Government
              </h1>
              <p className="text-[10px] sm:text-xs text-blue-700 font-medium leading-none">
                Revenue Performance Management & Reporting Portal
              </p>
            </div>
          </div>

          {/* CENTER SECTION - Last Update Indicator */}
          <div className="flex-1 flex justify-center items-center">
            {/* REDUCED: Changed py-1.5 to py-1 and text size to [10px] */}
            <span className="flex items-center gap-2 px-3 py-1 text-[10px] font-semibold text-red-700 bg-red-50 border border-red-200 rounded-full shadow-sm">
              <span className="relative flex h-1.5 w-1.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-red-600"></span>
              </span>
              <span className="uppercase tracking-wider">
                Last Data Sync: {lastUpdate}
              </span>
            </span>
          </div>

          {/* RIGHT SECTION */}
          <div className="flex items-center justify-between md:justify-end gap-4"> {/* REDUCED: gap-6 to gap-4 */}

            {/* User Info */}
            {/* REDUCED: py-2 to py-1 */}
            <div className="flex items-center gap-3 border-r pr-4 hover:bg-gray-50 rounded-lg px-3 py-1 transition-colors duration-200">
              <div className="text-right">
                <p className="text-xs font-semibold text-gray-900">
                  {user?.username || 'Loading...'}
                </p>
                <p className="text-[10px] text-gray-500 flex items-center justify-end">
                  <ShieldCheck className="w-2.5 h-2.5 mr-1 text-green-500" />
                  {user?.role || 'Loading...'} {user?.sub_county_name ? `- ${user.sub_county_name}` : ''}
                </p>
              </div>

              {/* REDUCED: User icon container w-10 to w-8 */}
              <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center border hover:border-blue-400">
                <User className="w-4 h-4 text-gray-500" />
              </div>
            </div>

            {/* Logout Button */}
            {/* REDUCED: py-2 to py-1 */}
            <button className="flex items-center gap-2 text-gray-600 hover:text-red-600 hover:bg-red-50 px-3 py-1 rounded-lg transition-all text-xs font-medium"
            onClick={logout} 
            >
              <LogOut className="w-3.5 h-3.5" />
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;